export const PropertyRatingPermissions = {
  PropertyRatingView :  {
    permissionsId: "f332192a-1ec6-44a4-c4d0-08dc683b0c43",
    permissionsName: "View Property Rating Configuration",
    description: null,
    componentsId: null,
    components: null
  }
};
